export enum NotificationEntityTypes {
  Message = 5,
  Documents = 9,
  Onboarding = 10,
  Netconn = 7,
  ProfileStatus = 11
}
